import { FC, HTMLAttributes } from "react";
import { useStyles } from "./TabsList.styles";
import clsx from "classnames";
import { Typography, TypographyColor, TypographyVariant } from "@onmo/ui";
import { useTranslation } from "react-i18next";

interface ITabsListProps {
  activeTab?: string;
  onChangeTab: (tab: string) => void;
  listTabs: string[];
}

export const TabsList: FC<ITabsListProps & HTMLAttributes<HTMLDivElement>> = ({
  listTabs,
  activeTab,
  onChangeTab,
  ...otherProps
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={clsx(classes.root, otherProps.className)}>
      {listTabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onChangeTab(tab)}
          className={clsx(classes.button, { active: activeTab === tab })}
          data-testid={`${tab
            .toLowerCase()
            .replace(/\s*\(\d+\)/g, "")
            .trim()
            .replace(/\s+/g, "-")}-tab`}
        >
          <Typography
            variant={
              activeTab === tab
                ? TypographyVariant.HeadingH8Bold
                : TypographyVariant.BodyB5Regular
            }
            color={
              activeTab === tab ? TypographyColor.Text1 : TypographyColor.Text2
            }
          >
            {t(`tab.${tab}`)}
          </Typography>
        </button>
      ))}
    </div>
  );
};
